// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── SubscriptionGateOverlay ─────────────────────────────── */

.sg-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(11, 31, 59, 0.72);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: sg-fade-in 0.2s ease;
}

@keyframes sg-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ── Card shell ─────────────────────────────────────────── */
.sg-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 40px 36px 32px;
  max-width: 420px;
  width: calc(100% - 32px);
  text-align: center;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  animation: sg-slide-up 0.25s ease;
}

@keyframes sg-slide-up {
  from { transform: translateY(16px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

/* ── Shield icon ─────────────────────────────────────────── */
.sg-shield-icon {
  width: 52px;
  height: 52px;
  color: #e53935;
  flex-shrink: 0;
}

/* ── Status badge ────────────────────────────────────────── */
.sg-status-badge {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: #fde8e8;
  color: #c62828;
}

/* ── Plan name ───────────────────────────────────────────── */
.sg-plan-name {
  font-size: 13px;
  font-weight: 600;
  color: #5a6a85;
  margin: 0;
  letter-spacing: 0.02em;
}

/* ── Title ───────────────────────────────────────────────── */
.sg-title {
  font-size: 20px;
  font-weight: 700;
  color: #0b1f3b;
  margin: 0;
  line-height: 1.3;
}

/* ── Body copy ───────────────────────────────────────────── */
.sg-body {
  font-size: 14px;
  line-height: 1.6;
  color: #4a5568;
  margin: 0;
  max-width: 340px;
}

/* ── CTA group ───────────────────────────────────────────── */
.sg-cta-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: 6px;
}

.sg-btn {
  width: 100%;
  padding: 13px 20px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
}

.sg-btn:active {
  transform: scale(0.98);
}

.sg-btn--primary {
  background: #1662e8;
  color: #ffffff;
}

.sg-btn--primary:hover {
  opacity: 0.88;
}

.sg-btn--secondary {
  background: #f0f4fb;
  color: #0b1f3b;
}

.sg-btn--secondary:hover {
  background: #e2e9f8;
}

/* ── Retry hint ──────────────────────────────────────────── */
.sg-retry-hint {
  font-size: 12px;
  color: #8898aa;
  margin: 0;
}

.sg-retry-hint strong {
  color: #4a5568;
}

/* ── Checking card ───────────────────────────────────────── */
.sg-card--checking {
  padding: 32px 40px;
  gap: 16px;
}

/* ── Spinner ─────────────────────────────────────────────── */
.sg-spinner {
  width: 40px;
  height: 40px;
  color: #1662e8;
  animation: sg-spin 0.8s linear infinite;
  flex-shrink: 0;
}

@keyframes sg-spin {
  to { transform: rotate(360deg); }
}

.sg-checking-text {
  font-size: 15px;
  font-weight: 600;
  color: #0b1f3b;
  margin: 0;
}

/* ── Dark-mode variant ───────────────────────────────────── */
@media (prefers-color-scheme: dark) {
  .sg-card {
    background: #1a2640;
  }

  .sg-title {
    color: #e8edf5;
  }

  .sg-body {
    color: #9babc2;
  }

  .sg-checking-text {
    color: #e8edf5;
  }

  .sg-btn--secondary {
    background: #243352;
    color: #e8edf5;
  }

  .sg-btn--secondary:hover {
    background: #2d3e65;
  }
}

/* App-level dark class variant (POS uses class-based dark mode) */
.dark .sg-card,
[data-theme="dark"] .sg-card {
  background: #1a2640;
}

.dark .sg-title,
[data-theme="dark"] .sg-title {
  color: #e8edf5;
}

.dark .sg-body,
[data-theme="dark"] .sg-body {
  color: #9babc2;
}
`, "",{"version":3,"sources":["webpack://./client/src/components/SubscriptionGate/index.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,kEAAkE;AAClE;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":["/* ── SubscriptionGateOverlay ─────────────────────────────── */\n\n.sg-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(11, 31, 59, 0.72);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  animation: sg-fade-in 0.2s ease;\n}\n\n@keyframes sg-fade-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* ── Card shell ─────────────────────────────────────────── */\n.sg-card {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 40px 36px 32px;\n  max-width: 420px;\n  width: calc(100% - 32px);\n  text-align: center;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  animation: sg-slide-up 0.25s ease;\n}\n\n@keyframes sg-slide-up {\n  from { transform: translateY(16px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}\n\n/* ── Shield icon ─────────────────────────────────────────── */\n.sg-shield-icon {\n  width: 52px;\n  height: 52px;\n  color: #e53935;\n  flex-shrink: 0;\n}\n\n/* ── Status badge ────────────────────────────────────────── */\n.sg-status-badge {\n  display: inline-block;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  background: #fde8e8;\n  color: #c62828;\n}\n\n/* ── Plan name ───────────────────────────────────────────── */\n.sg-plan-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #5a6a85;\n  margin: 0;\n  letter-spacing: 0.02em;\n}\n\n/* ── Title ───────────────────────────────────────────────── */\n.sg-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0b1f3b;\n  margin: 0;\n  line-height: 1.3;\n}\n\n/* ── Body copy ───────────────────────────────────────────── */\n.sg-body {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #4a5568;\n  margin: 0;\n  max-width: 340px;\n}\n\n/* ── CTA group ───────────────────────────────────────────── */\n.sg-cta-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  margin-top: 6px;\n}\n\n.sg-btn {\n  width: 100%;\n  padding: 13px 20px;\n  border-radius: 10px;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s, transform 0.1s;\n}\n\n.sg-btn:active {\n  transform: scale(0.98);\n}\n\n.sg-btn--primary {\n  background: #1662e8;\n  color: #ffffff;\n}\n\n.sg-btn--primary:hover {\n  opacity: 0.88;\n}\n\n.sg-btn--secondary {\n  background: #f0f4fb;\n  color: #0b1f3b;\n}\n\n.sg-btn--secondary:hover {\n  background: #e2e9f8;\n}\n\n/* ── Retry hint ──────────────────────────────────────────── */\n.sg-retry-hint {\n  font-size: 12px;\n  color: #8898aa;\n  margin: 0;\n}\n\n.sg-retry-hint strong {\n  color: #4a5568;\n}\n\n/* ── Checking card ───────────────────────────────────────── */\n.sg-card--checking {\n  padding: 32px 40px;\n  gap: 16px;\n}\n\n/* ── Spinner ─────────────────────────────────────────────── */\n.sg-spinner {\n  width: 40px;\n  height: 40px;\n  color: #1662e8;\n  animation: sg-spin 0.8s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes sg-spin {\n  to { transform: rotate(360deg); }\n}\n\n.sg-checking-text {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0b1f3b;\n  margin: 0;\n}\n\n/* ── Dark-mode variant ───────────────────────────────────── */\n@media (prefers-color-scheme: dark) {\n  .sg-card {\n    background: #1a2640;\n  }\n\n  .sg-title {\n    color: #e8edf5;\n  }\n\n  .sg-body {\n    color: #9babc2;\n  }\n\n  .sg-checking-text {\n    color: #e8edf5;\n  }\n\n  .sg-btn--secondary {\n    background: #243352;\n    color: #e8edf5;\n  }\n\n  .sg-btn--secondary:hover {\n    background: #2d3e65;\n  }\n}\n\n/* App-level dark class variant (POS uses class-based dark mode) */\n.dark .sg-card,\n[data-theme=\"dark\"] .sg-card {\n  background: #1a2640;\n}\n\n.dark .sg-title,\n[data-theme=\"dark\"] .sg-title {\n  color: #e8edf5;\n}\n\n.dark .sg-body,\n[data-theme=\"dark\"] .sg-body {\n  color: #9babc2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
